module.exports = __webpack_public_path__ + "img/Expression.62e03fa7.jpg";